import { Table, Text, Button, Flex, ScrollArea, rem, Tooltip } from "@mantine/core";
import { createStyles } from "@mantine/emotion";
import { useEffect, useState } from "react";
import { getRole } from "../../utils/CommonUtil";
import OrganizationAccountRequestModal from "./OrganizationAccountRequestModal";
import { useDisclosure } from "@mantine/hooks";

const useStyles = createStyles((_theme) => ({
  table: {
    "& td:nth-child(2)": {
      background: "transparent",
    },
    cursor: "pointer",
  },

  scrollArea: {
    maxHeight: 200,
    overflowY: "auto",
  },
}));

export default function OrganizationRequestList(props) {
  const [orgRequests, setOrgRequests] = useState(props.orgRequests);
  const [role] = useState(getRole());
  const [selectedOrg, setSelectedOrg] = useState(null);
  const { classes } = useStyles();

  const [opened, { open, close }] = useDisclosure(false);

  useEffect(() => {
    setOrgRequests(props.orgRequests);
  }, [props.orgRequests]);

  return (
    <>
      <Text> Organization Requests</Text>
      <ScrollArea.Autosize mah={300}>
        <Table className={classes.table} style={{ background: "none" }} highlightOnHover striped>
          <Table.Thead>
            <Table.Tr>
              <Table.Th>Name</Table.Th>
              <Table.Th>Address</Table.Th>
              <Table.Th>Email</Table.Th>
              {role === "admin" || role === "manager" ? <Table.Th>Distributor</Table.Th> : null}
              <Table.Th>Emails To Inform</Table.Th>
              <Table.Th>Actions</Table.Th>
            </Table.Tr>
          </Table.Thead>

          <Table.Tbody className={classes.scrollArea}>
            {orgRequests.map((item, index) => (
              <Table.Tr key={index}>
                <Table.Td>{item.name}</Table.Td>
                <Table.Td>{item.address}</Table.Td>
                <Table.Td>{item.email}</Table.Td>
                {role === "admin" || role === "manager" ? <Table.Td>{item.distId}</Table.Td> : null}

                <Table.Td>
                  <Tooltip label={item.emailsToInform.join("\n")} multiline w={rem(300)} withArrow>
                    <Text w={rem(100)} truncate="end">
                      {item.emailsToInform.join("\n")}
                    </Text>
                  </Tooltip>
                </Table.Td>

                <Table.Td>
                  {role === "distributor" ? (
                    <Button
                      onClick={() => props.deleteRequest(item._id)}
                      color="red"
                      variant="outline"
                      size="compact-xs"
                    >
                      <Text size={"xs"}>Delete</Text>
                    </Button>
                  ) : role === "admin" || role === "manager" ? (
                    <Flex>
                      <Button
                        mr={"xs"}
                        color="green"
                        size="compact-xs"
                        variant="outline"
                        onClick={() => {
                          setSelectedOrg(item);
                          open();
                        }}
                      >
                        <Text size={"xs"}>Accept</Text>
                      </Button>
                      <Button
                        onClick={() => props.deleteRequest(item._id)}
                        color="red"
                        variant="outline"
                        size="compact-xs"
                      >
                        <Text size={"xs"}>Reject</Text>
                      </Button>
                    </Flex>
                  ) : null}
                </Table.Td>
              </Table.Tr>
            ))}
          </Table.Tbody>
        </Table>
        <OrganizationAccountRequestModal opened={opened} close={close} org={selectedOrg} />
      </ScrollArea.Autosize>
    </>
  );
}
